var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRenderingOnly = function SvgRenderingOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.72 2.057a.75.75 0 0 1 .564 0l9.25 3.75a.75.75 0 0 1 .465.765v10.932a.75.75 0 0 1-.468.695l-9.24 3.744a.75.75 0 0 1-.299.055.8.8 0 0 1-.283-.055L2.47 18.2a.75.75 0 0 1-.468-.695V6.554l.001-.048v-.003a.75.75 0 0 1 .469-.695zm1.022 18.085L20.499 17V7.617l-7.75 3.14zM3.5 7.615V17l7.74 3.137.009-9.38zm8.501-4.054L4.75 6.502l7.253 2.94 7.254-2.94z"
  })));
};
export default SvgRenderingOnly;